<template>
  <div class="register-form">
    <h2 class="text-center">{{ $t("register") }}</h2>

    <validation-observer ref="observer" v-slot="{ passes }">
      <b-form
        :novalidate="true"
        class="register-form__form"
        @submit.stop.prevent="passes(register)"
      >
        <forms-validated-input
          mode="eager"
          name="email"
          :label="$t('email')"
          :rules="{ required: true, email: true }"
          type="email"
          :placeholder="$t('email')"
          v-model="email"
        />

        <forms-validated-input
          mode="eager"
          name="password"
          :label="$t('password')"
          :rules="{ required: true, min: 8 }"
          type="password"
          :placeholder="$t('password')"
          :description="$t('password_length')"
          v-model="password"
        />

        <forms-validated-input
          mode="eager"
          name="password_repeat"
          :label="$t('password_repeat')"
          :rules="{ required: true, is: password }"
          type="password"
          :placeholder="$t('password_repeat')"
          v-model="passwordRepeat"
        />

        <forms-validated-input
          mode="eager"
          name="invitationToken"
          :label="$t('invitation_token')"
          type="text"
          :placeholder="$t('invitation_token')"
          v-model="invitationToken"
        />

        <b-button type="submit" :disabled="loading" variant="primary" block class="btn-register">
          {{ $t("register_submit") }}
        </b-button>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import locales from "@/locales";

import FormsValidatedInput from "@/components/Forms/ValidatedInput.vue";

import { extractErrors } from "@/helpers";

export default {
  name: "registerBox",
  components: {
    FormsValidatedInput,
  },
  data() {
    return {
      password: "",
      passwordRepeat: "",
      invitationToken: this.$route.query.invitation ? this.$route.query.invitation : ""
    };
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
    email: {
      get() {
        return this.$store.state.register.email;
      },
      set(value) {
        return this.$store.commit("register/email", value);
      },
    },
  },
  methods: {
    async register() {
      this.$store.commit("loading", true);

      try {
        await this.$store.dispatch("register", {
          email: this.email,
          password: this.password,
          invitationToken: this.invitationToken,
        });

        await this.$store.dispatch("login", {
          email: this.email,
          password: this.password,
        });

        this.$router.replace("/register/2");
      } catch (e) {
        if (e.request) {
          switch (e.request.status) {
            case 422:
            default:
              this.$store.commit("addNotification", {
                content: extractErrors(e.response.data).join(", "),
                title: this.$i18n.t("register_error"),
                variant: "danger",
                type: "register",
              });
          }
        }
      }
    },
  },
  i18n: {
    messages: {
      fr: {
        ...locales.fr.components.register.registerform,
      },
      en: {
        ...locales.en.components.register.registerform,
      },
    },
  },
  mounted(){
    if(this.$route.query.email) {
      // autocomplete the value contained in the registration link
      this.email = this.$route.query.email;
    }
  }
};
</script>

<style lang="scss">
.register-form {
  h2 {
    margin-bottom: 20px;
  }

  .btn-primary {
    margin-left: 0;

    &.btn-register {
      margin-top: 40px;
    }
  }

  &__google {
    text-align: center;
  }

  &__form {
    margin-top: 32px;
  }
}
</style>
